import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowRight, ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SEOHead, { ADVISOR_PHONE_DISPLAY, ADVISOR_PHONE } from '../components/SEOHead';

const NotFound = () => {
  const { i18n } = useTranslation();
  const isTe = i18n.language === 'te';

  return (
    <div className="min-h-screen pt-32 pb-20 flex items-center justify-center bg-slate-50 dark:bg-slate-950 px-6">
      <SEOHead
        title={isTe ? '404 - పేజీ కనుగొనబడలేదు | VSR Insurance Plus' : '404 - Page Not Found | VSR Insurance Plus'}
        description={isTe ? 'మీరు వెతుకుతున్న పేజీ VSR Insurance Plusలో అందుబాటులో లేదు. మా ఎల్ఐసి పాలసీలు మరియు హెచ్‌డిఎఫ్‌సి ఎర్గో హెల్త్ ప్లాన్లను అన్వేషించండి.' : 'The page you are looking for does not exist on VSR Insurance Plus. Explore our LIC life insurance, child policies, and health plans.'}
        canonicalPath="/404"
        noIndex={true}
      />

      <div className="max-w-xl text-center space-y-6">
        <div className="w-20 h-20 bg-rose-100 dark:bg-rose-900/30 text-rose-600 rounded-full flex items-center justify-center mx-auto">
          <ShieldAlert className="w-10 h-10" />
        </div>

        <span className="text-xs font-bold text-slate-400 uppercase tracking-widest block">
          {isTe ? 'ఎర్రర్ 404' : 'Error 404'}
        </span>
        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 dark:text-white">
          {isTe ? 'పేజీ కనుగొనబడలేదు' : 'Page Not Found'}
        </h1>

        <p className="text-slate-600 dark:text-slate-400 text-base leading-relaxed">
          {isTe
            ? 'మీరు కోరిన వెబ్ చిరునామా లభించలేదు. ఇది తరలించబడి ఉండవచ్చు లేదా ప్రస్తుతం అందుబాటులో లేకపోవచ్చు.'
            : 'The requested address could not be found. It may have been moved, renamed, or is temporarily unavailable.'}
        </p>

        <div className="flex flex-wrap justify-center gap-4 pt-4">
          <Link
            to="/"
            className="px-6 py-3 bg-primary text-white rounded-xl font-bold hover:bg-blue-600 transition-colors flex items-center gap-2"
          >
            <Home className="w-4 h-4" /> {isTe ? 'హోమ్‌పేజీకి తిరిగి వెళ్లండి' : 'Return to Homepage'}
          </Link>
          <Link
            to="/lic-plans"
            className="px-6 py-3 bg-slate-200 dark:bg-slate-800 text-slate-800 dark:text-white rounded-xl font-bold hover:bg-slate-300 transition-colors flex items-center gap-2"
          >
            {isTe ? 'ఎల్ఐసి ప్లాన్లు చూడండి' : 'Browse LIC Plans'} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="pt-8 border-t border-slate-200 dark:border-slate-800 text-xs text-slate-500">
          {isTe ? (
            <>తక్షణ సాయం కావాలా? సీనియర్ సలహాదారు వి. ఎస్. రెడ్డి గారికి కాల్ చేయండి: <a href={`tel:${ADVISOR_PHONE}`} className="text-primary font-semibold hover:underline">{ADVISOR_PHONE_DISPLAY}</a></>
          ) : (
            <>Need immediate assistance? Call advisor V. S. Reddy at <a href={`tel:${ADVISOR_PHONE}`} className="text-primary font-semibold hover:underline">{ADVISOR_PHONE_DISPLAY}</a></>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
